"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getI18nInstance = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_cimpress_templates_json_1 = __importDefault(require("./locales/en-US/react-cimpress-templates.json"));
const react_cimpress_templates_json_2 = __importDefault(require("./locales/de-DE/react-cimpress-templates.json"));
const react_cimpress_templates_json_3 = __importDefault(require("./locales/fr-FR/react-cimpress-templates.json"));
const react_cimpress_templates_json_4 = __importDefault(require("./locales/it-IT/react-cimpress-templates.json"));
const react_cimpress_templates_json_5 = __importDefault(require("./locales/nl-NL/react-cimpress-templates.json"));
const react_cimpress_templates_json_6 = __importDefault(require("./locales/ja-JP/react-cimpress-templates.json"));
const react_cimpress_templates_json_7 = __importDefault(require("./locales/zh-CN/react-cimpress-templates.json"));
let i18nInstance = null;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.getI18nInstance = () => {
    if (!i18nInstance) {
        i18nInstance = i18next_1.default.createInstance();
        i18nInstance
            .init({
            lng: 'en',
            fallbackLng: 'en',
            resources: {
                en: { 'translations': react_cimpress_templates_json_1.default },
                de: { 'translations': react_cimpress_templates_json_2.default },
                fr: { 'translations': react_cimpress_templates_json_3.default },
                it: { 'translations': react_cimpress_templates_json_4.default },
                nl: { 'translations': react_cimpress_templates_json_5.default },
                ja: { 'translations': react_cimpress_templates_json_6.default },
                zh: { 'translations': react_cimpress_templates_json_7.default },
            },
            ns: 'translations',
            defaultNS: 'translations',
            debug: false,
            interpolation: {
                escapeValue: false,
            },
            react: {
                wait: true,
            },
            saveMissing: true,
            missingKeyHandler: (lng, ns, key, fallbackValue) => {
                // eslint-disable-next-line no-console
                console.log(lng, ns, key, fallbackValue);
            },
        });
    }
    return i18nInstance;
};
//# sourceMappingURL=i18n.js.map